import type { UpdateUserMutation, UpdateUserMutationVariables } from 'generated/graphql';
import { useUpdateUserMutation } from 'generated/graphql';
import type { ClientError } from 'graphql-request';
import { graphqlClient } from 'lib/api';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useUpdatePing } from './usePing';
import { enqueueSnackbar } from 'notistack';
import { match } from 'ts-pattern';

export default function useUpdateUser(
  options?: UseMutationOptions<
    UpdateUserMutation,
    ClientError,
    UpdateUserMutationVariables,
    unknown
  >,
  headers?: RequestInit['headers']
) {
  const updatePing = useUpdatePing();

  return useUpdateUserMutation<ClientError>(
    graphqlClient,
    {
      onSuccess: (res) => {
        const updatedUser = res?.updateUser;
        updatePing({ user: updatedUser });
      },
      onError: (error) => {
        const message = error.response.errors?.[0].message;
        match(message)
          .with('INVALID_USERNAME', () => {
            enqueueSnackbar('Username is invalid', { variant: 'error' });
          })
          .with('USERNAME_IS_BUSY', () => {
            enqueueSnackbar('Username is already taken', { variant: 'error' });
          })
          .otherwise(() => {
            enqueueSnackbar('An error occurred while updating the user', { variant: 'error' });
          });
      },
      ...options,
    },
    headers
  );
}
